<template>
  <v-row justify="center">
    <v-dialog v-model="show" max-width="30%">
      <v-card color="success" height="100%">
        <v-alert type="success" prominent border="left">
          <span class="ml-3">{{ successMessage }}</span>
        </v-alert>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="cancel">Ok</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "SuccessModal",
  computed: {
    ...mapGetters(["isSuccessModalOpen", "successMessage"]),
    show: {
      get: function () {
        return this.isSuccessModalOpen;
      },
      set: function (shoulShow) {
        this.showSuccessModal(shoulShow);
      },
    },
  },
  methods: {
    ...mapActions(["showSuccessModal"]),
    cancel() {
      this.show = false;
    },
  },
};
</script>